module.exports = __webpack_public_path__ + "img/secure-stripe-payment-logo.47cc6a78.svg";